export default __webpack_public_path__ + "static/media/huawei.0f223297.png";